export default __webpack_public_path__ + "roboto-v20-latin-300.eot";